module.exports = __webpack_public_path__ + "static/media/MK 15.ee61e18c.mp3";